angular.module("angularAvant.controllers").controller "ApplicationCtrl", [
  "$controller",
  "$filter",
  "$interval",
  "$location",
  "$q",
  "$sce",
  "$scope",
  "$stateParams",
  "$timeout",
  "$window",
  "ApplicationService",
  "AuthenticationService",
  "AvantErrorService",
  "CONFIG",
  "ConfigService",
  "CustomerApplicationService",
  "ProductService",
  "TealiumService",
  (
    $controller,
    $filter,
    $interval,
    $location,
    $q,
    $sce,
    $scope,
    $stateParams,
    $timeout,
    $window,
    ApplicationService,
    AuthenticationService,
    AvantErrorService,
    CONFIG,
    ConfigService,
    CustomerApplicationService,
    ProductService,
    TealiumService,
  ) ->

    # Custom form validations and helpers for content pages
    $scope.hasFormError = (form, inputName) ->
      form[inputName].$invalid && form.$submitted
    $scope.submitForm = (form, ev) ->
      form.$submitted = true
      if form.$invalid
        ev.preventDefault()
        $scope.$broadcast("form:invalid")
    $scope.removeCharacters = (form, inputName, char) ->
      if form.$valid && $scope[inputName]
        formattedValue = $scope[inputName].replace(new RegExp(char, 'g'), "")
        angular.element("##{inputName}")[0].value = formattedValue

    $scope.stageFromState = ->
      $stateParams.stage

    $scope.userIsAuthenticated = ->
      $scope.logged_in

    $scope.$on "customer:login", (_ev, logged_in) ->
      $scope.logged_in = !!logged_in

    $scope.displaySubHeader = ->
      ConfigService.applicationSubHeader?.enabledFor?.includes($scope.stageFromState())

    $scope.displaySubHeaderProductInfo = ->
      ConfigService.applicationSubHeader?.productInfoEnabledFor?.includes($scope.stageFromState())

    $scope.stickyHeader = ->
      ConfigService.header?.stickyFor?.includes($scope.stageFromState())

    $scope.sidebarImage = (type) ->
      ConfigService.sidebar?.images?[type]

    $scope.updatingProduct = false

    $scope.$on '$viewContentLoaded', ->
      return unless ConfigService.header?.myAccountDropdownDisabledOn
      if ConfigService.header.myAccountDropdownDisabledOn.includes($scope.stageFromState())
        # These are wrappers for jQuery methods. We need to do this because we
        # can't add ng-show/ng-hide attributes to the React components or pass
        # stage-specific props to them
        angular.element(document.querySelector('#my-account-dropdown')).hide()
        angular.element(document.querySelector('#left-header-links')).removeClass('header__links--desktop-only header__links--hide')
      else
        # Needed because the header does not rerender when progressing to the
        # next page
        angular.element(document.querySelector('#my-account-dropdown')).show()
        angular.element(document.querySelector('#left-header-links')).addClass('header__links--desktop-only header__links--hide')

    $scope.phone_application = false

    $scope.getPosMerchantRedirectUrl = (type) ->
      return "/login" unless $scope.customer_application
      if type is "approved"
        "/point_of_sale/approved/#{$scope.customer_application.id}"
      else
        "/point_of_sale/declined/#{$scope.customer_application.id}"

    angular.extend($scope, $controller('ApplicationMixinCtrl', {$scope: $scope, CustomerApplicationService: CustomerApplicationService, ApplicationService: ApplicationService}))

    tealiumClientSideApplicantData = ->
      {
        "acquisition_channel": $scope.customer_application_metadata?.acquisition_channel,
        "annual_fee": $scope.product?.annual_membership_fee_amount,
        "application_id": $scope.customer_application?.id
        "application_owner": $scope.customer_application?.application_owner,
        "application_source": $scope.customer_application?.source,
        "application_uuid": $scope.customer_application?.uuid,
        "credit_limit_amount": $scope.product?.credit_line_amount,
        "customer_id": $scope.customer?.id,
        "customer_uuid": $scope.customer?.uuid,
        "income_type": $scope.income?.income_type,
        "lead_source": $scope.customer_application?.lead_source,
        "loan_amount": $scope.product?.amount,
        "loan_apr": $scope.product?.apr_percentage,
        "loan_purpose": $scope.customer_application?.loan_purpose,
        "loan_term": $scope.product?.term,
        "monthly_net_income": $scope.income?.monthly_net_income,
        "product_type": $scope.customer_application?.product_type,
        "promotion_codes": _.map($scope.promotions, (p) -> p.id)
        "zip_code": $scope.customer_address?.zip || $scope.applicant_address?.zip
      }

    tealiumApplicantData = ->
      applicantData = {}
      serverSideApplicantData = $scope.tealium_applicant_data || {}

      _.each tealiumClientSideApplicantData(), (val, key) ->
        applicantData[key] = val || serverSideApplicantData[key] || ""
      _.each serverSideApplicantData, (val, key) ->
        unless applicantData[key]
          applicantData[key] = val || ""

      applicantData

    tealiumCommonPageData = ->
      $scope.tealium_common_application_page_data || {}

    $scope.hasTealiumEventData = (ev) ->
      Boolean($scope.tealium_event_data?[ev])

    tealiumData = (ev) ->
      Object.assign(
        {},
        tealiumApplicantData(),
        tealiumCommonPageData(),
        $scope.tealium_event_data?[ev] || {}
      )

    assignAdditionalData = (data, additionalData) ->
      _.each additionalData, (val, key) ->
        if !data[key] then data[key] = val
      data

    $scope.tealiumView = (ev, additionalData) ->
      return unless $scope.hasTealiumEventData(ev)
      checkUpdatingProduct = $interval( ->
        unless $scope.updatingProduct
          $interval.cancel(checkUpdatingProduct)

          data = tealiumData(ev)
          if additionalData
            data = assignAdditionalData(data, additionalData)

          TealiumService.view(data)
      , 1000)

    $scope.tealiumEvent = (ev, additionalData) ->
      return unless $scope.hasTealiumEventData(ev)
      checkUpdatingProduct = $interval( ->
        unless $scope.updatingProduct
          $interval.cancel(checkUpdatingProduct)

          data = tealiumData(ev)
          if additionalData then assignAdditionalData(data, additionalData)

          TealiumService.sendEvent(data)
      , 1000)

    # This needs to be called from content pages, hence its presence here. When
    # we refactor content page angular code, this may need to be moved
    $scope.tealiumContentPageEvent = (data) ->
      TealiumService.sendEvent(data)

    $scope.subheaderImage = (type) ->
      ConfigService.subheader?.images && ConfigService.subheader.images[type]
]
